import { create } from "zustand";

/**
 * useObrasDocumentosPagination
 */

type State = {
  status: number | null;
  situacao: number | null;
  nomeDescricao: string | null;
  dataVencimento: (Date | null)[] | null;
};

export const initialObrasDocumentosState = {
  status: 2,
  situacao: 2,
  nomeDescricao: null,
  dataVencimento: null,
};

export const useObrasDocumentosFilters = create<State>((set) => ({
  ...initialObrasDocumentosState,
}));